import {
  MarginSwyftxUserParams,
  GetTraderAccountsResponse,
  MarginParams,
  GetAccountDetailsResponse,
  TransferFundsRequest,
  TransferMarginFundsResponse,
  MarginInstrument,
  MarginPositionsQuery,
  GetTraderPositionsResponse,
  UpdatePositionRequest,
  UpdatePositionResponse,
  CreatePositionRequest,
  CreatePositionResponse,
  MarginOrdersQuery,
  GetTraderOrdersResponse,
  GetMarginTransactionsResponse,
  MarginTransactionQuery,
  StartMarginTransactionReportData,
  GetMarginTransactionReportJobResponse,
  GetMarginTransactionReportJobParams,
  GetPlannedMaintenanceResponse,
} from '@swyftx/margin/build/types';

import env from '@shared/config';

import { Methods, request } from '../rest';

const host = env.TRADE_MARGIN_SERVICE_URL;

const marginServiceEndpoints = {
  getMarginAccountDetails: ({ params }: { params: MarginParams }): GetAccountDetailsResponse =>
    request({
      path: '/trader-account/:traderAccountId',
      method: Methods.GET,
      params,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  getMarginAccounts: ({ params }: { params: MarginSwyftxUserParams }): GetTraderAccountsResponse =>
    request({
      path: '/trader-account',
      method: Methods.GET,
      params,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  withdrawFundsToSpot: ({
    params,
    data,
  }: {
    params: MarginParams;
    data: TransferFundsRequest;
  }): TransferMarginFundsResponse =>
    request({
      path: '/withdraw/:traderAccountId',
      method: Methods.POST,
      params,
      host,
      data,
      hideErrorToast: true,
      auth: true,
    }),

  depositFundsToDerivatives: ({
    params,
    data,
  }: {
    params: MarginParams;
    data: TransferFundsRequest;
  }): TransferMarginFundsResponse =>
    request({
      path: '/deposit/:traderAccountId',
      method: Methods.POST,
      params,
      host,
      data,
      hideErrorToast: true,
      auth: true,
    }),

  getMarginInstruments: (): MarginInstrument[] =>
    request({
      path: '/instruments',
      method: Methods.GET,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  getPositions: ({
    params,
    query,
  }: {
    params: MarginParams;
    query?: MarginPositionsQuery;
  }): GetTraderPositionsResponse =>
    request({
      path: '/position/:traderAccountId',
      method: Methods.GET,
      params,
      query,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  createPosition: ({ data }: { data: CreatePositionRequest }): CreatePositionResponse =>
    request({
      path: '/position',
      method: Methods.POST,
      data,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  updatePosition: ({ data }: { data: UpdatePositionRequest }): UpdatePositionResponse =>
    request({
      path: '/position',
      method: Methods.PATCH,
      data,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  getMarginOrders: ({ params, query }: { params: MarginParams; query?: MarginOrdersQuery }): GetTraderOrdersResponse =>
    request({
      path: '/orders/:traderAccountId',
      method: Methods.GET,
      params,
      query,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  getMarginTransactions: ({
    params,
    query,
  }: {
    params: MarginParams;
    query?: MarginTransactionQuery;
  }): GetMarginTransactionsResponse =>
    request({
      path: '/transactions/:traderAccountId',
      method: Methods.GET,
      params,
      query,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  startMarginTransactionReportJob: ({
    data,
  }: {
    data: StartMarginTransactionReportData;
  }): GetMarginTransactionReportJobResponse =>
    request({
      path: '/reports/transactions',
      method: Methods.POST,
      data,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  getMarginTransactionReportJob: ({
    params,
  }: {
    params: GetMarginTransactionReportJobParams;
  }): GetMarginTransactionReportJobResponse =>
    request({
      path: '/reports/transactions/:jobUuid',
      method: Methods.GET,
      params,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  downloadMarginTransactionReportJob: ({ params }: { params: GetMarginTransactionReportJobParams }): any =>
    request({
      path: '/reports/transactions/:jobUuid/download',
      responseType: 'blob',
      method: Methods.GET,
      params,
      host,
      hideErrorToast: true,
      auth: true,
    }),

  getMarginPlannedMaintenance: (): GetPlannedMaintenanceResponse =>
    request({
      path: '/planned-maintenance',
      method: Methods.GET,
      host,
      hideErrorToast: true,
      auth: true,
    }),
};

export default marginServiceEndpoints;
